import { Common } from './Common';

export class Reaction extends Common {
    creator: any;
    emp_id:string;
    feed_id:string;
    reaction:string;
    type:string;
}
